import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6127f77c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6127f77c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127f77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6127f77c')) {
      api.createRecord('6127f77c', component.options)
    } else {
      api.reload('6127f77c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6127f77c&scoped=true", function () {
      api.rerender('6127f77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exam/index.vue"
export default component.exports